module.exports = __webpack_public_path__ + "img/phonepe.5ae49b5b.svg";